/* jshint esversion: 9 */
/* eslint-disable */

export const OPEN_FORM = 'OPEN_FORM';
export const CLOSE_FORM = 'CLOSE_FORM';
export const TOGGLE_FORM = 'TOGGLE_FORM';
export const SUBMIT_FORM = 'SUBMIT_FORM';

export const UPDATE_STATUS = 'UPDATE_STATUS';
export const RANDOM_TASKS = 'RANDOM_TASKS';
export const EDIT_TASK = 'EDIT_TASK';
export const DELETE_TASK = 'DELETE_TASK';

export const FILTER_TABLE = 'FILTER_TABLE';
export const SEARCH_TABLE = 'SEARCH_TABLE';
export const SORT_TABLE = 'SORT_TABLE';

/* eslint-enable */
